import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('Handling auth callback...');
        const session = await fetchAuthSession();
        // console.log('Auth session fetched:', session);

        if (session.tokens) {
          console.log('Tokens found in session');

          // Successfully authenticated
          navigate('/');
        } else {
          console.log('No tokens found in session');
          navigate('/signout');
        }
      } catch (error) {
        console.error('Error handling auth callback:', error);
        navigate('/signout');
      }
    };

    handleCallback();
  }, [navigate]);

  return <div>Completing authentication...</div>;
}
